<template>
    <div class="plans-company">
        <div :class="['card', editCard ? 'edit-plan' : '']">
            <div class="card-header">
                <div>Plan config</div>
            </div>
            <div class="card-body">
                <div class="filter-row">
                    <div class="search-row">
                        <input type="text" class="form-control" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search">
                    </div>
                    <div class="filters-box">
                        <span>Filter:</span>
                        <a :class="activeFilter.carrier == 0 && activeFilter.inUse == 0 ? 'active' : ''" @click="addFilter(0,0)">All</a>
                        <a v-if="templateLists.length > 0" :class="activeFilter.carrier == 1 && activeFilter.inUse == 0 ? 'active' : ''" @click="addFilter(1,0)">Simon IoT</a>
                        <a v-if="ratePlanAssigned.length > 0 || ratePlanAll.length > 0" :class="activeFilter.carrier == 2 && activeFilter.inUse == 0 ? 'active' : ''" @click="addFilter(2,0)">T-mobile</a>
                        <a v-if="vodafoneRatePlanAssigned.length > 0 || vodafoneRatePlanAll.length > 0" :class="activeFilter.carrier == 3 && activeFilter.inUse == 0 ? 'active' : ''" @click="addFilter(3,0)">Vodafone</a>
                        <a v-if="koreRatePlanAssigned.length > 0 || koreRatePlanAll.length > 0" :class="activeFilter.carrier == 4 && activeFilter.inUse == 0 ? 'active' : ''" @click="addFilter(4,0)">Kore</a>
                        <a :class="activeFilter.carrier == 0 && activeFilter.inUse == 1 ? 'active' : ''" @click="addFilter(0,1)">Plans in use</a>
                        <a :class="activeFilter.carrier == 0 && activeFilter.inUse == 2 ? 'active' : ''" @click="addFilter(0,2)">Plans not in use</a>
                    </div>
                </div>
                <div class="active-plans">
                    <div class="plans-header">
                        <strong>Active Plans</strong>
                    </div>
                    <div class="body-plans">
                        <div class="plans-list templates-wrap">
                            <div v-if="((templateLists.length > 0) && !loading)" v-for="templateItem in templateLists" v-bind:key="'simon-plan-' + templateItem.id" :id="'template-' + templateItem.id" :data-ratePlanId="templateItem.id" :class="['item', 'simon-plan', 'template-item', 'plan', templateItem.categoryClass, (templateItem.active == 1) ? 'plan-active' + templateItem.id + ' active-plan' +  templateItem.id: 'plan-inactive' + templateItem.id + ' plan-inactive', editCard == templateItem.id ? 'edited-plan' : '',checkFilter(1,1) ? '' : 'plan-hidden']">
                                <div class="inner-template">
                                    <div class="carrier-logo simon">
                                        <img v-if="templateItem.categoryClass == 'flex'" src="../../assets/img/simon-logo-flex.svg" alt="">
                                        <img v-else-if="templateItem.categoryClass == 'nb-iot'" src="../../assets/img/simon-logo-nb-iot.svg" alt="">
                                        <img v-else-if="templateItem.categoryClass == 'cat-m1'" src="../../assets/img/simon-logo-m1.svg" alt="">
                                        <img v-else src="../../assets/img/darklogo.svg" alt="">

                                        <div class="controls">
                                            <i @click="editPlanSimon(templateItem)" :class="['fa', 'fa-pencil', (editCard != 0 && editCard != templateItem.id) ? 'turn-off' : '']"></i>
                                        </div>
                                    </div>
                                    <div class="plan-content showing-data">
                                        <div class="up">
                                            <div class="plan-name">
                                                <h2>{{ templateItem.name }}</h2>
                                            </div>

                                            <div class="type-plan">
                                                <span class="name">{{ templateItem.category }}</span>
                                                <span class="value">{{ templateItem.dataLimit }}</span>
                                            </div>

                                            <div class="options">
                                                <div class="option">
                                                    <span class="name">International Roaming</span>
                                                    <span class="value" v-if="templateItem.planOptions.hasRoaming == 'ON'">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>

                                                <div class="option">
                                                    <span class="name">Voice</span>
                                                    <span class="value" v-if="templateItem.planOptions.hasVoice == 'ON'">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>

                                                <!-- <div class="option">
                                                    <span class="name">Data Pooling</span>
                                                    <span class="value" v-if="templateItem.planOptions.dataPooling == 'ON'">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div> -->

                                                <div class="option">
                                                    <span class="name">SMS</span>
                                                    <span class="value" v-if="templateItem.planOptions.sms == 'ON'">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>

                                                <div class="option">
                                                    <span class="name">Static IP</span>
                                                    <span class="value" v-if="templateItem.planOptions.staticIp == 'ON'">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>

                                                <div class="option">
                                                    <span class="name">Hot Spot</span>
                                                    <span class="value" v-if="templateItem.planOptions.hotSpot == 'ON'">ON</span>
                                                    <span class="value" v-else>OFF</span>
                                                </div>

                                                <div class="option">
                                                    <span class="name">Throttle</span>
                                                    <div class="wrap-value">
                                                        <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleAt && templateItem.dataGuard.throttleAtUnit">{{templateItem.dataGuard.throttleAt}} {{templateItem.dataGuard.throttleAtUnit}}</span>
                                                        <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle && templateItem.dataGuard.throttleSpeed">{{templateItem.dataGuard.throttleSpeed}}</span>
                                                        <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasThrottle">ON</span>
                                                        <span class="value" v-else>OFF</span>
                                                    </div>
                                                </div>

                                                <div class="option">
                                                    <span class="name">Cap</span>
                                                    <div class="wrap-value">
                                                        <span v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap && templateItem.dataGuard.capAt && templateItem.dataGuard.capAtUnit">{{templateItem.dataGuard.capAt}} {{templateItem.dataGuard.capAtUnit}}</span>
                                                        <span class="value" v-if="templateItem.dataGuard && templateItem.dataGuard.hasCap">ON</span>
                                                        <span class="value" v-else>OFF</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="down">
                                                <div class="description">
                                                    <span class="name">Plan Description</span>
                                                    <span class="value">{{templateItem.description}}</span>
                                                </div>

                                                <div v-if="templateItem.planPrice" class="price-plan-wrapper">
                                                    <div :class="['start-price', templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount ? 'discounted' : '']">
                                                        <span>Start Price</span>
                                                        <em>${{templateItem.planPrice.basePrice.toFixed(2)}}</em>
                                                    </div>

                                                    <div :class="['overage-price', templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount ? 'discounted' : '']">
                                                        <span>Overage</span>
                                                        <em>${{templateItem.planPrice.ratePerOverageMb.toFixed(3)}}</em>
                                                    </div>

                                                    <div v-if="templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount" class="discount">
                                                        <span>Discount</span>
                                                        <em>- {{templateItem.planPrice.companyDiscount*100}}%</em>
                                                    </div>

                                                    <div v-if="templateItem.planOptions.staticIp == 'ON'" class="static-ip">
                                                        <span>Static IP</span>
                                                        <em>${{templateItem.planPrice.staticIpCharge.toFixed(2)}}</em>
                                                    </div>

                                                    <div v-if="templateItem.planOptions.sms == 'ON'" class="sms-price">
                                                        <span>SMS Price</span>
                                                        <em>${{templateItem.planPrice.smsCharge.toFixed(2)}}</em>
                                                    </div>

                                                    <div v-if="templateItem.planPrice.custom == false && templateItem.planPrice.companyDiscount" class="overage-price">
                                                        <span>Overage</span>
                                                        <em>${{templateItem.planPrice.discountedRatePerOverageMb.toFixed(3)}}</em>
                                                    </div>

                                                    <div class="cost-per-sim">
                                                        <span>Cost per SIM</span>
                                                        <em>${{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</em>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="edit-data">
                                        <div class="content-edit plan-content options">
                                            <div class="up">
                                                <div class="plan-name">
                                                    <h2>{{ templateItem.name }}</h2>
                                                </div>
                                                <div class="option">
                                                    <span class="name">Monthly SIM Price</span>
                                                    <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.basePrice">
                                                </div>

                                                <div class="option">
                                                    <span class="name">Overage Rate (MB)</span>
                                                    <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.ratePerOverageMb">
                                                </div>

                                                <div v-if="templateItem.planOptions.staticIp == 'ON'" class="option">
                                                    <span class="name">Static IP Rate</span>
                                                    <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.staticIpCharge">
                                                </div>

                                                <div class="option">
                                                    <span class="name">SMS Rate (per Message)</span>
                                                    <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.smsCharge">
                                                </div>

                                                <div class="option">
                                                    <span class="name">Suspend Rate</span>
                                                    <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.suspensionCharge">
                                                </div>
                                            </div>

                                            <div class="down">
                                                <div v-if="templateItem.planPrice" class="price-plan-wrapper">
                                                    <div class="start-price">
                                                        <span>Start Price</span>
                                                        <em>${{templateItem.planPrice.basePrice.toFixed(2)}}</em>
                                                    </div>

                                                    <div class="overage-price">
                                                        <span>Overage</span>
                                                        <em>${{templateItem.planPrice.discountedRatePerOverageMb.toFixed(3)}}</em>
                                                    </div>

                                                    <div v-if="templateItem.planOptions.staticIp == 'ON'" class="static-ip">
                                                        <span>Static IP</span>
                                                        <em>${{templateItem.planPrice.staticIpCharge.toFixed(2)}}</em>
                                                    </div>

                                                    <div v-if="templateItem.planOptions.sms == 'ON'" class="sms-price">
                                                        <span>SMS Price</span>
                                                        <em>${{templateItem.planPrice.smsCharge.toFixed(2)}}</em>
                                                    </div>

                                                    <div v-if="templateItem.planPrice.custom == false" class="discount">
                                                        <span>Discount</span>
                                                        <em>- {{templateItem.planPrice.companyDiscount*100}}%</em>
                                                    </div>

                                                    <div class="cost-per-sim">
                                                        <span>Cost per SIM</span>
                                                        <em>${{templateItem.planPrice.discountedBasePrice.toFixed(2)}}</em>
                                                    </div>
                                                </div>
                                                <div class="footer-edit">
                                                    <button v-if="templateItem.planPrice && templateItem.planPrice.custom" class="btn-link" @click="resetToDefault(templateItem.id, 1)">Reset to Default</button>
                                                    <button class="btn btn-light" @click="cancelPlanEditSimon(templateItem)">Cancel</button>

                                                    <button class="btn btn-success" :disabled="isSimonChanged(editData, initialData) && blockEditPrice == false" @click="saveRatePlanPrice(templateItem)"><span v-if="blockEditPrice">Reset</span><span v-else>Save</span></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-for="item in ratePlanAssigned" v-bind:key="'tmobile-plan-' + item.id" :class="['item', 'magenta', 'template-item', 'plan', `active-plan${item.id}`, editCard == item.id ? 'edited-plan' : '', checkFilter(2,1) ? '' : 'plan-hidden']">
                                <div class="inner-template">
                                    <div class="carrier-logo tmobile">
                                        <img :src="require('../../assets/img/magenta-logo.svg')" alt="">

                                        <div class="controls">
                                            <i :class="['fa', 'fa-pencil', (editCard != 0 && editCard != item.id) ? 'turn-off' : '']" @click="editPlanTmobile(item)"></i>
                                            <i @click="delteRatePlan(item.id)" :class="['fa', 'fa-arrow-down', (editCard != 0 && editCard != item.id) ? 'turn-off' : '']"></i>
                                        </div>
                                    </div>
                                    <div class="showing-data">
                                        <div class="plan-content">
                                            <div class="up">
                                                <div class="plan-name">
                                                    <h2 v-if="item.customName">{{ item.customName }}</h2>
                                                    <h2 v-else>{{item.ratePlan.name}}</h2>
                                                </div>

                                                <div class="type-plan">
                                                    <div class="name">{{ item.ratePlan.ratePlanCategory.planCategoryName }}</div>
                                                </div>

                                                <div class="options">
                                                    <div class="option">
                                                        <span class="name">Static IP</span>
                                                        <span class="value" v-if="item.staticIp">ON</span>
                                                        <span class="value" v-else>OFF</span>
                                                    </div>

                                                    <span class="option">
                                                        <span class="name">SOC Code</span>
                                                        <span class="value" v-if="item.ratePlan.socCode">{{item.ratePlan.socCode}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </span>
                                                    <span class="option usage-alert">
                                                        <div>
                                                            <span class="name">Usage Alert</span>
                                                            <span class="value" v-if="item.usageAlert">{{item.usageAlertValue}}</span>
                                                        </div>
                                                        <span class="value" v-if="item.usageAlert">ON</span>
                                                        <span class="value" v-else>OFF</span>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="down">
                                                <div class="description">
                                                    <span class="name">Plan Description</span>
                                                    <span class="value" v-if="item.customDescription">{{item.customDescription}}</span>
                                                    <span class="value" v-else>{{item.ratePlan.description}}</span>
                                                </div>

                                                <div class="price">
                                                    <span class="name">Cost Per Line</span>
                                                    <span class="value" v-if="item.customUnitPrice">{{item.customUnitPrice}}</span>
                                                    <span class="value" v-else>--</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="edit-data">
                                        <div class="content-edit options">
                                            <div class="option">
                                                <span class="name">Plan Name</span>
                                                <input type="text" class="edit-plan-input" v-model="item.customName" value="Tmobiles Plan Name Here">
                                            </div>
                                            <div class="option">
                                                <span class="name">Plan Description</span>
                                                <textarea class="edit-plan-input"  v-model="item.customDescription"></textarea>
                                            </div>
                                        </div>

                                        <div class="footer-edit">
                                            <button class="btn btn-light" @click="cancelPlanEditTmobile(item)">Cancel</button>

                                            <button class="btn btn-success" :disabled="isTmobileChanged(item, initialData)" @click="updatePlan(item)">Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(item, index) in vodafoneRatePlanAssigned" v-bind:key="'vodafone-plans-' + item.id" :class="['item', 'vodafone', 'template-item', 'plan', `active-plan${item.id}`, editCard == item.id ? 'edited-plan' : '', checkFilter(3,1) ? '' : 'plan-hidden']">
                                <div class="inner-template">
                                    <div class="carrier-logo vodafone">
                                        <img :src="require('../../assets/img/vodafone-logo-white.svg')" alt="">

                                        <div class="controls">
                                            <i :class="['fa', 'fa-pencil', (editCard != 0 && editCard != item.id) ? 'turn-off' : '']" @click="editPlanVodafone(item)"></i>
                                            <i @click="delteRatePlan(item.id)" :class="['fa', 'fa-arrow-down', (editCard != 0 && editCard != item.id) ? 'turn-off' : '']"></i>
                                        </div>
                                    </div>
                                    <div class="showing-data">
                                        <div class="plan-content">
                                            <div class="up">
                                                <div class="plan-name">
                                                    <h2 v-if="item.customName && item.customName != null">{{item.customName}}</h2>
                                                    <h2 v-else>{{item.ratePlan.name}}</h2>
                                                </div>

                                                <div class="type-plan">
                                                    <div class="name">{{item.ratePlan.ratePlanCategory.planCategoryName}}</div>
                                                </div>

                                                <div class="options">
                                                    <div class="option">
                                                        <span class="name">Data Limit</span>
                                                        <span class="value" v-if="item.ratePlan.dataLimit">{{item.ratePlan.dataLimit.dataLimitName}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </div>

                                                    <div class="option">
                                                        <span class="name">Provisioning profile</span>
                                                        <span class="value no-uppercase" v-if="item.customProvisioningProfile">{{item.customProvisioningProfile}}</span>
                                                        <span class="value no-uppercase" v-else-if="item.ratePlan.provisioningProfile && item.ratePlan.provisioningProfile.profileName">{{item.ratePlan.provisioningProfile.profileName}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </div>

                                                    <div class="option">
                                                        <span class="name">APN</span>
                                                        <span class="value no-uppercase" v-if="item.ratePlan.provisioningProfile && item.ratePlan.provisioningProfile.apnType">{{item.ratePlan.provisioningProfile.apnType}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </div>

                                                    <div class="option">
                                                        <span class="name">IMEI Match Rule</span>
                                                        <span class="value" v-if="item.ratePlan.imeiMatch">ON</span>
                                                        <span class="value" v-else>OFF</span>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="down">
                                                <div class="description">
                                                    <span class="name">Plan Description</span>
                                                    <span v-if="item.customDescription" class="value">{{item.customDescription}}</span>
                                                    <span v-else-if="item.ratePlan.planDescription" class="value">{{item.ratePlan.planDescription}}</span>
                                                    <span v-else class="value">--</span>
                                                </div>
                                            </div>

                                            <div v-if="item.priceResponse" class="price-settings">
                                                <div :class="['price-row', item.priceResponse.custom == false && item.priceResponse.companyDiscount ? 'discounted' : '']">
                                                    <span class="name">Base Price</span>
                                                    <span class="value">$ {{item.priceResponse.basePrice.toFixed(2)}}</span>
                                                </div>
                                                <div :class="['price-row', item.priceResponse.custom == false && item.priceResponse.companyDiscount ? 'discounted' : '']">
                                                    <span class="name">Overage per MB</span>
                                                    <span class="value">$ {{item.priceResponse.ratePerOverageMb.toFixed(3)}}</span>
                                                </div>
                                                <div v-if="item.priceResponse.companyDiscount && item.priceResponse.custom == false" class="price-row discount">
                                                    <span>Discount</span>
                                                    <span class="value">- {{item.priceResponse.companyDiscount*100}}%</span>
                                                </div>
                                                <div v-if="item.priceResponse.companyDiscount && item.priceResponse.custom == false" class="price-row discount-value">
                                                    <span>Base Price after discount</span>
                                                    <span class="value">$ {{item.priceResponse.discountedBasePrice.toFixed(2)}}</span>
                                                </div>
                                                <div v-if="item.priceResponse.companyDiscount && item.priceResponse.custom == false" class="price-row discount-value">
                                                    <span>Overage per MB after discount</span>
                                                    <span class="value">$ {{item.priceResponse.ratePerOverageMb.toFixed(3)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="edit-data">
                                        <div class="content-edit options">
                                            <div class="option">
                                                <span class="name">Plan Name</span>
                                                <input type="text" class="edit-plan-input" v-model="editData.customName">
                                            </div>
                                            <div class="option">
                                                <span class="name">Provisioning profile</span>
                                                <input type="text" class="edit-plan-input" v-model="editData.customProvisioningProfile">
                                            </div>
                                            <div class="option">
                                                <span class="name">Plan Description</span>
                                                <textarea class="edit-plan-input"  v-model="editData.customDescription"></textarea>
                                            </div>
                                            <div class="option">
                                                <span class="name">Base Price</span>
                                                <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.basePrice">
                                            </div>
                                            <div class="option">
                                                <span class="name">Overage per MB</span>
                                                <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.ratePerOverageMb">
                                            </div>
                                        </div>

                                        <div class="footer-edit">
                                            <button v-if="item.priceResponse && item.priceResponse.custom" class="btn-link" @click="resetToDefault(item.ratePlan.id, 3)">Reset to Default</button>
                                            <button class="btn btn-light" @click="cancelPlanEditVodafone(item.ratePlan.id)">Cancel</button>

                                            <button class="btn btn-success" :disabled="isVodafoneChanged(editData, initialData) && blockEditPrice == false" @click="updatePlanVodafone(item)"><span v-if="blockEditPrice">Reset</span><span v-else>Save</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(item, index) in koreRatePlanAssigned" v-bind:key="'kore-plans-' + item.id" :class="['item', 'kore', 'template-item', 'plan', `active-plan${item.id}`, editCard == item.id ? 'edited-plan' : '', checkFilter(4,1) ? '' : 'plan-hidden']">
                                <div class="inner-template">
                                    <div class="carrier-logo kore">
                                        <img :src="require('../../assets/img/kore-plan-logo.svg')" alt="">

                                        <div class="controls">
                                            <i :class="['fa', 'fa-pencil', (editCard != 0 && editCard != item.id) ? 'turn-off' : '']" @click="editPlanKore(item)"></i>
                                            <i :class="['fa', 'fa-arrow-down', (editCard != 0 && editCard != item.id) ? 'turn-off' : '']" @click="delteRatePlan(item.id)"></i>
                                        </div>
                                    </div>
                                    <div class="showing-data">
                                        <div class="plan-content">
                                            <div class="up">
                                                <div class="plan-name">
                                                    <h2 v-if="item.customName && item.customName != null">{{item.customName}}</h2>
                                                    <h2 v-else>{{item.ratePlan.name}}</h2>
                                                </div>

                                                <div class="type-plan">
                                                    <div class="name">{{item.ratePlan.ratePlanCategory.planCategoryName}}</div>
                                                </div>

                                                <div class="options">
                                                    <div v-if="item.ratePlan.ratePlanCategory && item.ratePlan.ratePlanCategory.planCategoryId == 14" class="option">
                                                        <span class="name">Data Limit</span>
                                                        <span class="value" v-if="item.ratePlan.dataLimit">{{item.ratePlan.dataLimit.dataLimitName}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </div>

                                                    <div v-if="item.ratePlan.activationProfile && item.ratePlan.activationProfile.dataPlanName" class="option">
                                                        <span class="name">Data Plan</span>
                                                        <span class="value">{{item.ratePlan.activationProfile.dataPlanName}}</span>
                                                    </div>

                                                    <div v-if="item.ratePlan.activationProfile && item.ratePlan.activationProfile.smsPlanName" class="option">
                                                        <span class="name">SMS Plan</span>
                                                        <span class="value">{{item.ratePlan.activationProfile.smsPlanName}}</span>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="down">
                                                <div class="description">
                                                    <span class="name">Plan Description</span>
                                                    <span v-if="item.customDescription" class="value">{{item.customDescription}}</span>
                                                    <span v-else-if="item.ratePlan.planDescription" class="value">{{item.ratePlan.planDescription}}</span>
                                                    <span v-else class="value">--</span>
                                                </div>
                                            </div>

                                            <div v-if="item.priceResponse" class="price-settings">
                                                <div :class="['price-row', item.priceResponse.custom == false && item.priceResponse.companyDiscount ? 'discounted' : '']">
                                                    <span class="name">Base Price</span>
                                                    <span class="value">$ {{item.priceResponse.basePrice.toFixed(2)}}</span>
                                                </div>
                                                <div :class="['price-row', item.priceResponse.custom == false && item.priceResponse.companyDiscount ? 'discounted' : '']">
                                                    <span class="name">Overage per MB</span>
                                                    <span class="value">$ {{item.priceResponse.ratePerOverageMb.toFixed(3)}}</span>
                                                </div>
                                                <div class="price-row">
                                                    <span class="name">SMS</span>
                                                    <span class="value">$ {{item.priceResponse.smsCharge.toFixed(2)}}</span>
                                                </div>
                                                <div v-if="item.priceResponse.companyDiscount && item.priceResponse.custom == false" class="price-row discount">
                                                    <span>Discount</span>
                                                    <span class="value">- {{item.priceResponse.companyDiscount*100}}%</span>
                                                </div>
                                                <div v-if="item.priceResponse.companyDiscount && item.priceResponse.custom == false" class="price-row discount-value">
                                                    <span>Base Price after discount</span>
                                                    <span class="value">$ {{item.priceResponse.discountedBasePrice.toFixed(2)}}</span>
                                                </div>
                                                <div v-if="item.priceResponse.companyDiscount && item.priceResponse.custom == false" class="price-row discount-value">
                                                    <span>Overage per MB after discount</span>
                                                    <span class="value">$ {{item.priceResponse.ratePerOverageMb.toFixed(3)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="edit-data">
                                        <div class="content-edit options">
                                            <div class="option">
                                                <span class="name">Plan Name</span>
                                                <input type="text" class="edit-plan-input" v-model="editData.customName">
                                            </div>
                                            <div class="option">
                                                <span class="name">Plan Description</span>
                                                <textarea class="edit-plan-input"  v-model="editData.customDescription"></textarea>
                                            </div>
                                        </div>

                                        <div class="content-edit options">
                                            <div class="option">
                                                <span class="name">Base Price</span>
                                                <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.basePrice">
                                            </div>
                                            <div class="option">
                                                <span class="name">Overage per MB</span>
                                                <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.ratePerOverageMb">
                                            </div>
                                            <div class="option">
                                                <span class="name">SMS</span>
                                                <input type="text" :disabled="blockEditPrice" class="edit-plan-input" v-model="editData.smsCharge">
                                            </div>
                                        </div>

                                        <div class="footer-edit">
                                            <button v-if="item.priceResponse && item.priceResponse.custom" class="btn-link" @click="resetToDefault(item.ratePlan.id, 4)">Reset to Default</button>
                                            <button class="btn btn-light" @click="cancelPlanEditKore(item.ratePlan.id)">Cancel</button>

                                            <button class="btn btn-success" :disabled="isKoreChanged() && blockEditPrice == false" @click="updatePlanKore(item)"><span v-if="blockEditPrice">Reset</span><span v-else>Save</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="inactive-plans">
                    <div v-if="checkFilter(2,2)" class="plans-header">
                        <strong>Inactive T-mobile Plans</strong>
                    </div>
                    <div class="body-plans">
                        <div class="plans-list templates-wrap">
                            <div v-for="(item, index) in ratePlanAll" v-bind:key="'tmobile-plans-' + item.id" :class="['item', 'magenta', 'template-item', 'plan', `inactive-plan${item.id}`, checkFilter(2,2) ? '' : 'plan-hidden']">
                                <div class="inner-template">
                                    <div class="carrier-logo tmobile">
                                        <img :src="require('../../assets/img/magenta-logo.svg')" alt="">

                                        <div class="controls">
                                            <i @click="addRatePlan(item.id)" class="fa fa-arrow-up"></i>
                                        </div>
                                    </div>
                                    <div class="showing-data">
                                        <div class="plan-content">
                                            <div class="up">
                                                <div class="plan-name">
                                                    <h2>{{item.name}}</h2>
                                                </div>

                                                <div class="type-plan">
                                                    <div class="name">{{item.ratePlanCategory.planCategoryName}}</div>
                                                </div>

                                                <div class="options">
                                                    <div class="option">
                                                        <span class="name">Static IP</span>
                                                        <span class="value" v-if="item.staticIp">ON</span>
                                                        <span class="value" v-else>OFF</span>
                                                    </div>

                                                    <span class="option">
                                                        <span class="name">SOC Code</span>
                                                        <span class="value" v-if="item.socCode">{{item.socCode}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </span>
                                                    <span class="option usage-alert">
                                                        <div>
                                                            <span class="name">Usage Alert</span>
                                                            <span class="value" v-if="item.usageAlert">{{item.usageAlertValue}}</span>
                                                        </div>
                                                        <span class="value" v-if="item.usageAlert">ON</span>
                                                        <span class="value" v-else>OFF</span>
                                                    </span>
                                                </div>
                                            </div>

                                            <div class="down">
                                                <div class="description">
                                                    <span class="name">Plan Description</span>
                                                    <span class="value">{{item.customDescription}}</span>
                                                </div>

                                                <div class="price">
                                                    <span class="name">Cost Per Line</span>
                                                    <span class="value">{{item.customUnitPrice}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="inactive-plans">
                    <div v-if="checkFilter(3,2)" class="plans-header">
                        <strong>Inactive Vodafone Plans</strong>
                    </div>
                    <div class="body-plans">
                        <div class="plans-list templates-wrap">
                            <div v-for="(item, index) in vodafoneRatePlanAll" v-bind:key="'vodafone-plans-' + item.id" :class="['item', 'vodafone', 'template-item', 'plan', `inactive-plan${item.id}`, checkFilter(3,2) ? '' : 'plan-hidden', editCard == item.id ? 'edited-plan' : '']">
                                <div class="inner-template">
                                    <div class="carrier-logo vodafone">
                                        <img :src="require('../../assets/img/vodafone-logo-white.svg')" alt="">

                                        <div class="controls">
                                            <i @click="addVodafoneRatePlan(item.id)" class="fa fa-arrow-up"></i>
                                        </div>
                                    </div>
                                    <div class="showing-data">
                                        <div class="plan-content">
                                            <div class="up">
                                                <div class="plan-name">
                                                    <h2>{{item.name}}</h2>
                                                </div>

                                                <div class="type-plan">
                                                    <div class="name">{{item.ratePlanCategory.planCategoryName}}</div>
                                                </div>

                                                <div class="options">
                                                    <div class="option">
                                                        <span class="name">Data Limit</span>
                                                        <span class="value" v-if="item.dataLimit">{{item.dataLimit.dataLimitName}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </div>

                                                    <div class="option">
                                                        <span class="name">Provisioning profile</span>
                                                        <span class="value no-uppercase" v-if="item.provisioningProfile && item.provisioningProfile.profileName">{{item.provisioningProfile.profileName}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </div>

                                                    <div class="option">
                                                        <span class="name">APN</span>
                                                        <span class="value no-uppercase" v-if="item.provisioningProfile && item.provisioningProfile.apnType">{{item.provisioningProfile.apnType}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </div>

                                                    <div class="option">
                                                        <span class="name">IMEI Match Rule</span>
                                                        <span class="value" v-if="item.imeiMatch">ON</span>
                                                        <span class="value" v-else>OFF</span>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="down">
                                                <div class="description">
                                                    <span class="name">Plan Description</span>
                                                    <span v-if="item.planDescription" class="value">{{item.planDescription}}</span>
                                                    <span v-else class="value">--</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="edit-data">
                                        <div class="content-edit options">
                                            <div class="option">
                                                <span class="name">Base Price</span>
                                                <input type="number" min="0.01" class="edit-plan-input" v-model="editData.basePrice">
                                            </div>
                                            <div class="option">
                                                <span class="name">Overage per MB</span>
                                                <input type="number" min="0.001" class="edit-plan-input" v-model="editData.ratePerOverageMb">
                                            </div>
                                            <div class="footer-edit">
                                                <button class="btn btn-light" @click="cancelPlanAddVodafone()">Cancel</button>
                                                <button class="btn btn-success" :disabled="isVodafoneAddChanged()" @click="addPlanVodafone(item)">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="inactive-plans">
                    <div v-if="checkFilter(4,2)" class="plans-header">
                        <strong>Inactive Kore Plans</strong>
                    </div>
                    <div class="body-plans">
                        <div class="plans-list templates-wrap">
                            <div v-for="(item, index) in koreRatePlanAll" v-bind:key="'kore-plans-' + item.id" :class="['item', 'kore', 'template-item', 'plan', `inactive-plan${item.id}`, checkFilter(4,2) ? '' : 'plan-hidden']">
                                <div class="inner-template">
                                    <div class="carrier-logo kore">
                                        <img :src="require('../../assets/img/kore-plan-logo.svg')" alt="">

                                        <div class="controls">
                                            <i @click="addRatePlan(item.id)" class="fa fa-arrow-up"></i>
                                        </div>
                                    </div>
                                    <div class="showing-data">
                                        <div class="plan-content">
                                            <div class="up">
                                                <div class="plan-name">
                                                    <h2>{{item.name}}</h2>
                                                </div>

                                                <div class="type-plan">
                                                    <div class="name">{{item.ratePlanCategory.planCategoryName}}</div>
                                                </div>

                                                <div class="options">
                                                    <div v-if="item.ratePlanCategory && item.ratePlanCategory.planCategoryId == 14" class="option">
                                                        <span class="name">Data Limit</span>
                                                        <span class="value" v-if="item.dataLimit">{{item.dataLimit.dataLimitName}}</span>
                                                        <span class="value" v-else>--</span>
                                                    </div>

                                                    <div v-if="item.activationProfile && item.activationProfile.dataPlanName" class="option">
                                                        <span class="name">Data Plan</span>
                                                        <span class="value">{{item.activationProfile.dataPlanName}}</span>
                                                    </div>

                                                    <div v-if="item.activationProfile && item.activationProfile.smsPlanName" class="option">
                                                        <span class="name">SMS Plan</span>
                                                        <span class="value">{{item.activationProfile.smsPlanName}}</span>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="down">
                                                <div class="description">
                                                    <span class="name">Plan Description</span>
                                                    <span v-if="item.planDescription" class="value">{{item.planDescription}}</span>
                                                    <span v-else class="value">--</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Axios from 'axios'
import globalStore from '../../variables'
import { Switch as cSwitch } from "@coreui/vue";
import FTScheckbox from "../../ftsComponents/FTScheckbox";


export default {
    name: 'CompanyPlans',
    components: {
        FTScheckbox,
        cSwitch
    },
    data() {
        return {
            editCard: false,
            blockEditPrice: false,
            filter: null,
            companyId: this.$route.params.id,
            ratePlanAll: [],
            vodafoneRatePlanAll: [],
            koreRatePlanAll: [],
            tempRatePlanAll: [],
            tempVodafoneRatePlanAll: [],
            tempKoreRatePlanAll: [],
            ratePlanAssigned: [],
            tempRatePlanAssigned: [],
            vodafoneRatePlanAssigned: [],
            koreRatePlanAssigned: [],
            tempVodafoneRatePlanAssigned: [],
            tempKoreRatePlanAssigned: [],
            searchStringAll: '',
            searchStringAssigned: '',
            timerSearch: '',
            labelIcon: {
                dataOn: "\u2713",
                dataOff: "\u2715"
            },
            editData: {},
            initialData: {},
            templates: [],
            templateLists: [],
            tempTemplateLists: [],
            vodafonePlans: [],
            loading: false,
            activeFilter: {
                carrier: 0,
                inUse: 0
            }
        }
    },
    methods: {
        saveRatePlanPrice(templateItem) {
            if (this.blockEditPrice) {
                Axios.patch(`${globalStore.data.restApiUrl}/billing-pricing/remove-custom-price/${templateItem.id}`)
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Updating price done',
                            text: 'Updating price finished',
                            duration: 5000,
                        });
                        this.editCard = 0;
                        this.getSimonPlans()
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Updating price error',
                            text: 'Updating price for rate plan error',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            } else {
                let prices = {
                    basePrice: this.editData.basePrice,
                    ratePerOverageMb: this.editData.ratePerOverageMb,
                    smsCharge: this.editData.smsCharge,
                    staticIpCharge: this.editData.staticIpCharge,
                    suspensionCharge: this.editData.suspensionCharge
                }
                Axios.patch(`${globalStore.data.restApiUrl}/billing-pricing/change-price/${templateItem.id}`, prices)
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Updating price done',
                            text: 'Updating price finished',
                            duration: 5000,
                        });
                        this.editCard = 0;
                        this.getSimonPlans()
                    }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Updating price error',
                        text: 'Updating price for rate plan error',
                        duration: 5000,
                    });
                    console.log(error)
                })
            }
        },
        getSimonPlans() {
            this.templates = []
            this.templateLists = []
            this.tempTemplateLists = []
            Axios.get(globalStore.data.restApiUrl + "/account/rate-plans?companyId=" + this.companyId).then(result => {
                this.templates = result.data.response;

                if (this.templates.length) {
                    this.templates.map(item => {
                        var optionsSms = "OFF";
                        var optionsDataPooling = "OFF";
                        var roaming = "OFF";
                        var tier = null;
                        var staticIp = "OFF";
                        var voice = "OFF";
                        var hotSpot = item.hotSpotPlan ? "ON" : "OFF";

                        if (item.planOptions) {
                            item.planOptions.map(itemOptions => {
                                if (itemOptions.planOptionName == "SMS") {
                                    optionsSms = "ON";
                                }

                                if (itemOptions.planOptionName == "Data Pooling") {
                                    optionsDataPooling = "ON";
                                }

                                if  (itemOptions.planOptionName == "Tier 1 International Roaming") {
                                    roaming = "ON";
                                    tier = 'Tier 1';
                                }

                                if  (itemOptions.planOptionName == "Tier 2 International Roaming") {
                                    roaming = "ON";
                                    tier = 'Tier 2';
                                }

                                if (itemOptions.planOptionName == "Static IP") {
                                    staticIp = "ON";
                                }

                                if (itemOptions.planOptionName == "Voice") {
                                    voice = "ON";
                                }
                            });
                        }

                        var dataGuard = {
                            hasThrottle: 0,
                            throttleAt: 0,
                            throttleAtUnit: "",
                            throttleSpeed: 0,
                            hasCap: 0,
                            capAt: 0,
                            capAtUnit: ""
                        };

                        if (item.dataGuard && item.dataGuard.hasThrottle == 1) {
                            dataGuard.hasThrottle = 1;

                            if (item.dataGuard.throttleAt > 0) {
                                dataGuard.throttleAt = item.dataGuard.throttleAt;
                                dataGuard.throttleAtUnit = item.dataGuard.throttleAtUnit;
                            }

                            if (item.dataGuard.throttleSpeed && item.dataGuard.throttleSpeed.throttleSpeedId > 0) {
                                dataGuard.throttleSpeed = item.dataGuard.throttleSpeed.throttleSpeedName;
                            }
                        }

                        if (item.dataGuard && item.dataGuard.hasCap == 1) {
                            dataGuard.hasCap = 1;

                            if (item.dataGuard.capAt > 0) {
                                dataGuard.capAt = item.dataGuard.capAt;
                                dataGuard.capAtUnit = item.dataGuard.capAtUnit;
                            }
                        }

                        if (dataGuard.hasThrottle == 0) {
                            delete dataGuard.throttleAt
                            delete dataGuard.throttleAtUnit
                            delete dataGuard.throttleSpeed
                        }

                        if (dataGuard.hasCap == 0) {
                            delete dataGuard.capAt
                            delete dataGuard.capAtUnit
                        }

                        let alerts = {
                            alertAt: 0,
                            unit: "mb",
                            additionalNotifications: {
                                sms: false,
                                email: false
                            }
                        }

                        var categoryClass = item.planCategory.planCategoryName;
                        categoryClass = categoryClass.replace(/\s/g, "").toLowerCase();

                        var tempTemplateData = {
                            id: item.ratePlanId,
                            name: item.planName,
                            active: item.active,
                            description: item.planDescription,
                            category: item.planCategory.planCategoryName,
                            categoryClass: categoryClass,
                            dataLimit: item.dataLimit.dataLimitName,
                            planOptions: {
                                dataPooling: optionsDataPooling,
                                sms: optionsSms,
                                hasRoaming: roaming,
                                hasVoice: voice,
                                hotSpot: hotSpot,
                                tier: tier,
                                staticIp: staticIp
                            },
                            dataGuard,
                            usageAlert: item.usageAlert,
                            planPrice: item.planPrice,
                            customCostPerSim: {
                                basePrice: (item.planPrice && item.planPrice.basePrice) ? item.planPrice.basePrice : 0,
                                ratePerOverageMb: (item.planPrice && item.planPrice.ratePerOverageMb) ? item.planPrice.ratePerOverageMb.toFixed(3) : 0,
                                staticIpCharge: (item.planPrice && item.planPrice.staticIpCharge) ? item.planPrice.staticIpCharge : 0,
                                smsCharge: (item.planPrice && item.planPrice.smsCharge) ? item.planPrice.smsCharge : 0,
                                suspensionCharge: (item.planPrice && item.planPrice.suspensionCharge) ? item.planPrice.suspensionCharge : 0
                            }
                        };

                        if (item.planPrice && item.planPrice.staticIpCharge && staticIp == 'ON') {
                            item.planPrice.discountedBasePrice += item.planPrice.staticIpCharge
                        }

                        this.templateLists.push(tempTemplateData);
                        this.tempTemplateLists.push(tempTemplateData);
                    });
                }

                this.templates = this.templateLists;
            });
        },
        searchKeyUp() {
            clearTimeout(this.timerSearch)
            this.timerSearch = setTimeout(() => {
                this.searchPlans()
            }, 500)
        },
        searchKeyDown() {
            clearTimeout(this.timerSearch)
        },
        searchPlans() {
            if (this.filter.length > 0) {
                this.templateLists = this.tempTemplateLists;
                this.ratePlanAssigned = this.tempRatePlanAssigned
                this.ratePlanAll = this.tempRatePlanAll
                this.vodafoneRatePlanAll = this.tempVodafoneRatePlanAll
                this.vodafoneRatePlanAssigned = this.tempVodafoneRatePlanAssigned

                this.templateLists = this.templateLists.filter(item => {
                    return ((item.name && item.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (item.description && item.description.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1));
                })

                this.ratePlanAssigned = this.ratePlanAssigned.filter(item => {
                    return ((item.ratePlan.name && Boolean(item.customName) == false && item.ratePlan.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (Boolean(item.ratePlan.description) && Boolean(item.customDescription) == false && item.ratePlan.description.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (Boolean(item.ratePlan.socCode) && item.ratePlan.socCode.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (Boolean(item.customName) && item.customName.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (Boolean(item.customDescription) && item.customDescription.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1));
                })

                this.ratePlanAll = this.ratePlanAll.filter(item => {
                    return (item.name && item.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (item.description && item.description.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (item.socCode && item.socCode.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1)
                })

                this.vodafoneRatePlanAll = this.vodafoneRatePlanAll.filter(item => {
                    return (item.name && item.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (item.description && item.description.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (item.provisioningProfile.profileName && item.provisioningProfile.profileName.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1)
                })
                this.vodafoneRatePlanAssigned = this.vodafoneRatePlanAssigned.filter(item => {
                    return ((item.ratePlan.name && Boolean(item.customName) == false && item.ratePlan.name.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (Boolean(item.ratePlan.description) && Boolean(item.customDescription) == false && item.ratePlan.description.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (Boolean(item.ratePlan.provisioningProfile) && Boolean(item.customProvisioningProfile) == false && item.ratePlan.provisioningProfile.profileName.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (Boolean(item.ratePlan.provisioningProfile) && item.ratePlan.provisioningProfile.apnType.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (Boolean(item.customName) && item.customName.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1) || (Boolean(item.customDescription) && item.customDescription.toLowerCase().indexOf(this.filter.toLowerCase()) !== -1));
                })
            } else if (this.filter.length == 0) {
                this.templateLists = this.tempTemplateLists;
                this.ratePlanAssigned = this.tempRatePlanAssigned
                this.ratePlanAll = this.tempRatePlanAll
                this.vodafoneRatePlanAll = this.tempVodafoneRatePlanAll
                this.vodafoneRatePlanAssigned = this.tempVodafoneRatePlanAssigned
            }
        },
        editPlanSimon(item) {
            this.blockEditPrice = false
            this.editCard = item.id;
            this.editData = {
                basePrice: item.customCostPerSim.basePrice,
                ratePerOverageMb: item.customCostPerSim.ratePerOverageMb,
                smsCharge: item.customCostPerSim.smsCharge,
                staticIpCharge: item.customCostPerSim.staticIpCharge,
                suspensionCharge: item.customCostPerSim.suspensionCharge
            }
            this.initialData = {
                basePrice: item.customCostPerSim.basePrice,
                ratePerOverageMb: item.customCostPerSim.ratePerOverageMb,
                smsCharge: item.customCostPerSim.smsCharge,
                staticIpCharge: item.customCostPerSim.staticIpCharge,
                suspensionCharge: item.customCostPerSim.suspensionCharge
            }
        },
        hardResetToDefault(id, carrier) {
            if (carrier == 1) {
                Axios.patch(`${globalStore.data.restApiUrl}/billing-pricing/remove-custom-price/${id}`)
                    .then( response => {
                        this.getSimonPlans()
                        this.editCard = false;
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Reseting to default price error',
                            text: 'Something went wrong during reseting price, please contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            } else if (carrier == 4) {
                Axios.patch(`${globalStore.data.restApiUrl}/billing-pricing/rate-plan/remove-custom-price/${id}?companyId=${this.companyId}`)
                    .then( response => {
                        Axios.get(globalStore.data.restApiUrl + '/billing-pricing/rate-plan/default-price/' + id + '?companyId=' + this.companyId)
                            .then( response => {
                                if (this.editData.basePrice && response.data.basePrice) {
                                    this.editData.basePrice = response.data.basePrice
                                }
                                if (this.editData.ratePerOverageMb && response.data.ratePerOverageMb) {
                                    this.editData.ratePerOverageMb = response.data.ratePerOverageMb
                                }
                                if (this.editData.smsCharge && response.data.smsCharge) {
                                    this.editData.smsCharge = response.data.smsCharge
                                }
                                this.getListOfAssocation();
                                this.editCard = false;
                            })
                            .catch(error => {
                                this.$notify({
                                    type: 'warn',
                                    group: 'notification',
                                    title: 'Reseting to default price error',
                                    text: 'Something went wrong during reseting price, please contact support.',
                                    duration: 5000,
                                });
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Reseting to default price error',
                            text: 'Something went wrong during reseting price, please contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            } 
        },
        resetToDefault(id, carrier) {
            if (carrier == 1) {
                this.blockEditPrice = true
                Axios.get(globalStore.data.restApiUrl + '/billing-pricing/default-price/' + id)
                    .then( response => {
                        if (this.editData.basePrice && response.data.basePrice) {
                            this.editData.basePrice = response.data.basePrice
                        }
                        if (this.editData.ratePerOverageMb && response.data.ratePerOverageMb) {
                            this.editData.ratePerOverageMb = response.data.ratePerOverageMb
                        }
                        if (this.editData.smsCharge && response.data.smsCharge) {
                            this.editData.smsCharge = response.data.smsCharge
                        }
                        if (this.editData.staticIpCharge && response.data.staticIpCharge) {
                            this.editData.staticIpCharge = response.data.staticIpCharge
                        }
                        if (this.editData.suspensionCharge && response.data.suspensionCharge) {
                            this.editData.suspensionCharge = response.data.suspensionCharge
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Reseting to default price error',
                            text: 'Something went wrong during reseting price, please contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            } else {
                Axios.get(globalStore.data.restApiUrl + '/billing-pricing/rate-plan/default-price/' + id + '?companyId=' + this.companyId)
                    .then( response => {
                        this.blockEditPrice = true
                        if (this.editData.basePrice && response.data.basePrice) {
                            this.editData.basePrice = response.data.basePrice
                        }
                        if (this.editData.ratePerOverageMb && response.data.ratePerOverageMb) {
                            this.editData.ratePerOverageMb = response.data.ratePerOverageMb
                        }
                        if (this.editData.smsCharge && response.data.smsCharge) {
                            this.editData.smsCharge = response.data.smsCharge
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Reseting to default price error',
                            text: 'Something went wrong during reseting price, please contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            }
        },
        isSimonChanged(currentData, initialData) {
            return (currentData.basePrice == initialData.basePrice && currentData.ratePerOverageMb == initialData.ratePerOverageMb && currentData.smsCharge == initialData.smsCharge && currentData.staticIpCharge == initialData.staticIpCharge && currentData.suspensionCharge == initialData.suspensionCharge)
        },
        editPlanTmobile(item) {
            this.editCard = item.id;
            this.editData = {
                customName: item.customName,
                customDescription: item.customDescription
            }
            this.initialData = {
                customName: item.customName,
                customDescription: item.customDescription
            }
        },
        isTmobileChanged(currentData, initialData) {
            let disable = true
            if (initialData.customName != null) {
                currentData.customName != initialData.customName
                disable = false
            } else {
                if (currentData.customName != '' && currentData.customName != null) {
                    disable = false
                }
            }
            if (initialData.customDescription != null) {
                currentData.customDescription != initialData.customDescription
                disable = false
            } else {
                if (currentData.customDescription != '' && currentData.customDescription != null) {
                    disable = false
                }
            }
            return disable
        },
        editPlanVodafone(item) {
            this.blockEditPrice = false
            this.editCard = item.id;
            this.editData = {
                customName: item.customName,
                customDescription: item.customDescription,
                customProvisioningProfile: item.customProvisioningProfile,
                basePrice: item.priceResponse.basePrice,
                ratePerOverageMb: item.priceResponse.ratePerOverageMb
            }
            this.initialData = {
                customName: item.customName,
                customDescription: item.customDescription,
                customProvisioningProfile: item.customProvisioningProfile,
                basePrice: item.priceResponse.basePrice,
                ratePerOverageMb: item.priceResponse.ratePerOverageMb
            }
        },
        editPlanKore(item) {
            this.blockEditPrice = false
            this.editCard = item.id;
            this.editData = {
                customName: item.customName,
                customDescription: item.customDescription,
                basePrice: item.priceResponse.basePrice,
                ratePerOverageMb: item.priceResponse.ratePerOverageMb,
                smsCharge: item.priceResponse.smsCharge
            }
            this.initialData = {
                customName: item.customName,
                customDescription: item.customDescription,
                basePrice: item.priceResponse.basePrice,
                ratePerOverageMb: item.priceResponse.ratePerOverageMb,
                smsCharge: item.priceResponse.smsCharge
            }
        },
        isVodafoneChanged(currentData, initialData) {
            let disable = true

            if (initialData.customName != null) {
                currentData.customName != initialData.customName
                disable = false
            } else {
                if (currentData.customName != '' && currentData.customName != null) {
                    disable = false
                }
            }
            if (initialData.customDescription != null) {
                currentData.customDescription != initialData.customDescription
                disable = false
            } else {
                if (currentData.customDescription != '' && currentData.customDescription != null) {
                    disable = false
                }
            }
            if (initialData.customProvisioningProfile != null) {
                currentData.customProvisioningProfile != initialData.customProvisioningProfile
                disable = false
            } else {
                if (currentData.customProvisioningProfile != '' && currentData.customProvisioningProfile != null) {
                    disable = false
                }
            }
            if (initialData.basePrice != 0 && initialData.basePrice != '') {
                if (currentData.basePrice != initialData.basePrice) {
                    disable = false
                }
            }
            if (initialData.ratePerOverageMb != 0 && initialData.ratePerOverageMb != '') {
                if (currentData.ratePerOverageMb != initialData.ratePerOverageMb) {
                    disable = false
                }
            }
            return disable
        },
        isKoreChanged() {
            let disable = true

            if (this.initialData.customName != null) {
                this.editData.customName != this.initialData.customName
                disable = false
            } else {
                if (this.editData.customName != '' && this.editData.customName != null) {
                    disable = false
                }
            }
            if (this.initialData.customDescription != null) {
                this.editData.customDescription != this.initialData.customDescription
                disable = false
            } else {
                if (this.editData.customDescription != '' && this.editData.customDescription != null) {
                    disable = false
                }
            }

            if (this.initialData.basePrice != 0 && this.initialData.basePrice != '') {
                if (this.editData.basePrice != this.initialData.basePrice) {
                    disable = false
                }
            }
            if (this.initialData.ratePerOverageMb != 0 && this.initialData.ratePerOverageMb != '') {
                if (this.editData.ratePerOverageMb != this.initialData.ratePerOverageMb) {
                    disable = false
                }
            }
            if (this.initialData.smsCharge != 0 && this.initialData.smsCharge != '') {
                if (this.editData.smsCharge != this.initialData.smsCharge) {
                    disable = false
                }
            }

            return disable
        },
        cancelPlanEditSimon(item) {
            this.resetToDefault(item.id, 1)
            this.editCard = 0;

            this.editData = {};
        },
        cancelPlanEditTmobile(item) {
            this.resetToDefault(item.id, 2)
            this.editCard = 0;

            item.customName = this.editData.customName;
            item.customDescription = this.editData.customDescription;
            this.editData = {};
        },
        cancelPlanEditVodafone(ratePlanId) {
            this.resetToDefault(ratePlanId, 3)
            this.editCard = 0;
            this.editData = {};
        },
        cancelPlanEditKore(ratePlanId) {
            this.resetToDefault(ratePlanId, 4)
            this.editCard = 0;
            this.editData = {};
        },
        searchRow() {
            if (this.filter.length > 2) {
                this.searchStringAssigned = `?search=${this.filter}`
                this.searchStringAll = `&search=${this.filter}`
            } else {
                this.searchString = ''
            }
            this.getListAllRatePlans()
            this.getListOfAssocation()
        },
        getListAllRatePlans() {
            Axios.get(`${globalStore.data.restApiUrl}/rate-plans/2/inactive?companyId=${this.companyId}`)
                .then(response => {
                    this.ratePlanAll = response.data
                    this.tempRatePlanAll = response.data
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Rate Plan Details  - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        getListOfAssocation() {
            Axios.get(`${globalStore.data.restApiUrl}/rate-plans/associations-by-company?companyId=${this.companyId}`)
                .then(response => {
                    let tmobilePlans = [];
                    let vodafonePlans = [];
                    let korePlans = [];
                    for (let item of response.data) {
                        if (item.ratePlan.carrierId == 2) {
                            tmobilePlans.push(item)
                        } else if (item.ratePlan.carrierId == 3) {
                            vodafonePlans.push(item)
                        } else if (item.ratePlan.carrierId == 4) {
                            korePlans.push(item)
                        }
                    }
                    this.ratePlanAssigned = tmobilePlans
                    this.tempRatePlanAssigned = tmobilePlans
                    this.vodafoneRatePlanAssigned = vodafonePlans
                    this.tempVodafoneRatePlanAssigned = vodafonePlans
                    this.koreRatePlanAssigned = korePlans
                    this.tempKoreRatePlanAssigned = korePlans
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving Rate Plan Details  - Contact Support',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        getVodafonePlans() {
            Axios.get(`${globalStore.data.restApiUrl}/rate-plans/3/inactive?companyId=${this.companyId}`)
                .then(response => {
                    this.vodafoneRatePlanAll = response.data
                    this.tempVodafoneRatePlanAll = response.data
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving Rate Plan Details  - Contact Support',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        getKorePlans() {
            Axios.get(`${globalStore.data.restApiUrl}/rate-plans/4/inactive?companyId=${this.companyId}`)
                .then(response => {
                    this.koreRatePlanAll = response.data
                    this.tempKoreRatePlanAll = response.data
                }).catch(error => {
                this.$notify({
                    type: 'warn',
                    group: 'notification',
                    title: 'Getting data error',
                    text: 'Error Retrieving Rate Plan Details  - Contact Support',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        addRatePlan(id) {
            let ratePlansId = [];
            ratePlansId.push(id);

            const ratePlanId = {
                ratePlanIds: ratePlansId
            }

            Axios.put(`${globalStore.data.restApiUrl}/rate-plans/associations-by-company?companyId=${this.companyId}`, ratePlanId)
                .then(response => {
                    this.getListOfAssocation()
                    this.getListAllRatePlans()
                    this.getVodafonePlans();
                    this.getKorePlans();
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Saving data error',
                        text: 'Error Saving Rate Plan Details  - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        addVodafoneRatePlan(id) {
            this.editCard = id
            this.editData = {
                basePrice: '',
                ratePerOverageMb: ''
            }
        },
        cancelPlanAddVodafone() {
            this.editData = {}
            this.editCard = 0
        },
        isVodafoneAddChanged() {
            return (this.editData.basePrice == '' || this.editData.ratePerOverageMb == '')
        },
        addPlanVodafone() {
            let parsedData = {
                ratePlanId: this.editCard,
                changePriceRequest : {
                    basePrice: this.editData.basePrice,
                    ratePerOverageMb: this.editData.ratePerOverageMb
                }
            }
            Axios.put(globalStore.data.restApiUrl + '/rate-plans/vf/associate?companyId=' + this.companyId, parsedData)
                .then(response => {
                    this.getListOfAssocation()
                    this.getListAllRatePlans()
                    this.getVodafonePlans();
                    this.getKorePlans();
                    this.editCard = 0
                    this.editData = {}
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Plan added',
                        text: 'You added Vodafone plan to company',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Plan not added',
                        text: 'An error has occured during adding plan to company.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        delteRatePlan(id) {
            Axios.delete(`${globalStore.data.restApiUrl}/rate-plans/associations/${id}?companyId=${this.companyId}`)
                .then(response => {
                    if (response.status == '204') { //
                        this.getListOfAssocation()
                        this.getListAllRatePlans()
                        this.getVodafonePlans();
                        this.getKorePlans();
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Deleting data error',
                        text: 'Error Deleting Rate Plan - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        updatePlan(item) {
            let currentRatePlan = this.ratePlanAssigned.filter(plan => {
                return plan.id == item.id
            });

            currentRatePlan = currentRatePlan[0]

            let dataToChange = {
                customName: currentRatePlan.customName,
                customDescription: currentRatePlan.customDescription
            }

            Axios.patch(`${globalStore.data.restApiUrl}/rate-plans/associations/${item.id}?companyId=${this.companyId}`, dataToChange)
                .then(response => {
                    if (response.status == 204) {
                        this.getListOfAssocation()
                        this.editCard = 0;
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Updating data error',
                        text: 'Error Saving Modifying Plan Details  - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })

        },
        updatePlanVodafone(item) {
            let callsRequired = 0
            let callsFinished = 0
            if (this.editData.customDescription != this.initialData.customDescription || this.editData.customName != this.initialData.customName || this.editData.customProvisioningProfile != this.initialData.customProvisioningProfile) {
                callsRequired++

                let parsedDataPlan = {
                    customDescription: this.editData.customDescription,
                    customName: this.editData.customName,
                    customProvisioningProfile: this.editData.customProvisioningProfile
                }

                Axios.patch(`${globalStore.data.restApiUrl}/rate-plans/associations/${item.id}`, parsedDataPlan)
                    .then(response => {
                        if (response.status == 204) {
                            callsFinished++
                            if (callsFinished == callsRequired) {
                                this.getListOfAssocation()
                                this.editCard = 0;
                                this.editData = {}
                            }
                        }
                    }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Updating data error',
                        text: 'Error Saving Modifying Plan Details  - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
            }

            if (this.blockEditPrice) {
                callsRequired++
                Axios.patch(`${globalStore.data.restApiUrl}/billing-pricing/rate-plan/remove-custom-price/${item.ratePlan.id}?companyId=${this.companyId}`)
                    .then(response => {
                        callsFinished++
                        if (callsFinished == callsRequired) {
                            this.getListOfAssocation()
                            this.editCard = 0;
                            this.editData = {}
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Updating data error',
                            text: 'Error Saving Modifying Plan Prices  - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            } else if (this.editData.basePrice != this.initialData.basePrice || this.editData.ratePerOverageMb != this.initialData.ratePerOverageMb) {
                callsRequired++
                let id = item.ratePlan.id
                let parsedDataPrices = {
                    basePrice: Number(this.editData.basePrice),
                    ratePerOverageMb: Number(this.editData.ratePerOverageMb)
                }
                Axios.patch(`${globalStore.data.restApiUrl}/billing-pricing/rate-plan/change-price/${id}?companyId=${this.companyId}`, parsedDataPrices)
                    .then(response => {
                        callsFinished++
                        if (callsFinished == callsRequired) {
                            this.getListOfAssocation()
                            this.editCard = 0;
                            this.editData = {}
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Updating data error',
                            text: 'Error Saving Modifying Plan Prices  - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            }
        },
        updatePlanKore(item) {
            let callsRequired = 0
            let callsFinished = 0
            if (this.editData.customDescription != this.initialData.customDescription || this.editData.customName != this.initialData.customName) {
                callsRequired++

                let parsedDataPlan = {
                    customDescription: this.editData.customDescription,
                    customName: this.editData.customName
                }

                Axios.patch(`${globalStore.data.restApiUrl}/rate-plans/associations/${item.id}?companyId=${this.companyId}`, parsedDataPlan)
                    .then(response => {
                        if (response.status == 204) {
                            callsFinished++
                            if (callsFinished == callsRequired) {
                                this.getListOfAssocation()
                                this.editCard = 0;
                                this.editData = {}
                            }
                        }
                    }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Updating data error',
                        text: 'Error Saving Modifying Plan Details  - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
            }
            if (this.blockEditPrice) {
                callsRequired++
                Axios.patch(`${globalStore.data.restApiUrl}/billing-pricing/rate-plan/remove-custom-price/${item.ratePlan.id}?companyId=${this.companyId}`)
                    .then(response => {
                        callsFinished++
                        if (callsFinished == callsRequired) {
                            this.getListOfAssocation()
                            this.editCard = 0;
                            this.editData = {}
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Updating data error',
                            text: 'Error Saving Modifying Plan Prices  - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            } else if (this.editData.basePrice != this.initialData.basePrice || this.editData.ratePerOverageMb != this.initialData.ratePerOverageMb || this.editData.smsCharge != this.initialData.smsCharge) {
                callsRequired++
                let id = item.ratePlan.id
                let parsedDataPrices = {
                    basePrice: Math.round(this.editData.basePrice * 1000) / 1000,
                    ratePerOverageMb: Math.round(this.editData.ratePerOverageMb * 1000) / 1000,
                    smsCharge: Math.round(this.editData.smsCharge * 100) / 100
                }
                Axios.patch(`${globalStore.data.restApiUrl}/billing-pricing/rate-plan/change-price/${id}?companyId=${this.companyId}`, parsedDataPrices)
                    .then(response => {
                        callsFinished++
                        if (callsFinished == callsRequired) {
                            this.getListOfAssocation()
                            this.editCard = 0;
                            this.editData = {}
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Updating data error',
                            text: 'Error Saving Modifying Plan Prices  - Contact Support',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            }
        },
        addFilter(carrier, inUse) {
            this.activeFilter.carrier = carrier;
            this.activeFilter.inUse = inUse;
        },
        checkFilter(carrier, inUse) {
            let carrierCondition = false
            if (carrier == this.activeFilter.carrier || this.activeFilter.carrier == 0) {
                carrierCondition = true
            }
            let inUseCondition = false
            if (inUse == this.activeFilter.inUse || this.activeFilter.inUse == 0) {
                inUseCondition = true
            }
            return (carrierCondition && inUseCondition)
        }
    },
    created() {
        this.getListAllRatePlans()
        this.getVodafonePlans()
        this.getKorePlans();
        this.getListOfAssocation()
        this.getSimonPlans()
    }
}
</script>

<style lang="scss" scoped>
.plans-company {
    .card {
        background-color: #F0F3F5;
        position: relative;
        overflow: hidden;
        z-index: 0;

        &::before {
            display: none;
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: rgba(47, 53, 58, .50);
            z-index: 1;
            pointer-events: none;
        }

        .card-body {
            background-color: transparent;

            .plans-header {
                margin-bottom: 12px;
            }

            .filter-row {
                display: flex;
                align-items: center;

                .filters-box {
                    margin-left: 20px;

                    span {
                        font-weight: 700;
                    }

                    a {
                        margin-left: 10px;
                        cursor: pointer;

                        &.active,
                        &:hover {
                            font-weight: 700;
                        }
                    }
                }
            }
        }

        &.edit-plan {
            &::before {
                display: block;
            }
        }
        .card-header {
            background-color: transparent;
        }
    }
    .templates-wrap {
        .template-item {
            .inner-template {
                .plan-content {
                    .price-settings {
                        padding: 8px 0;
                        border-top: 1px solid #c9cfd4;
                        .price-row {
                            display: flex;
                            justify-content: space-between;
                            font-size: 12px;
                            padding: 0 12px;
                            &.discount {
                                .value {
                                    color: #FF6F00;
                                }
                            }
                            &.discount-value {
                                .value {
                                    color: #55CD6C;
                                    font-weight: 700;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
.search-row {
    input {
        max-width: 400px;
    }
}

.active-plans {
    margin: 20px 0;
}

.simon-plan {
    .edit-data {
        .plan-name {
            margin-bottom: 20px !important;
        }
    }
}

.dark-theme {
    .plans-company {
        .card {
            background-color: #3a4149;
            .plans-list {
                .plan {
                    background-color: #3a4149;
                    border: 1px solid #1d1f20;
                    .row-description {
                        color: #edeeef;
                    }
                    .row {
                        border-color: #1d1f20;
                    }
                    &.edited-plan {
                        .edit-data {
                            .header-edit {
                                background-color: #3a4149;
                                border-color: #1d1f20;
                            }

                            .content-edit {
                                background-color: #3a4149;
                                .row {
                                    .edit-plan-input {
                                        background-color: #40484f;
                                        color: #edeeef;
                                    }
                                }
                            }

                            .footer-edit {
                                background-color: #3a4149;
                            }
                        }
                    }
                }
            }
        }
    }
}

</style>
